import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function remapKeys<T extends object>(
  source: T,
  map: Record<keyof T, string>
): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  
  for (const key in source) {
    const newKey = map[key as keyof T] || key;
    result[newKey] = source[key as keyof T];
  }

  return result;
}
